import { kevinAuthAPI } from 'apis/config';
import { ICoupon } from '../../utils/types/operationTypes';

export const couponApis = {
  // Get coupon list for a specific project
  getCouponList: (projectId: number) =>
    kevinAuthAPI.get(`/coupon/${projectId}`).then((res) => res.data),

  // Create a serial coupon for a specific project
  createSerialCoupon: (projectId: number, createSerialCouponDto: ICoupon) =>
    kevinAuthAPI
      .post(`/coupon/${projectId}/serial`, createSerialCouponDto)
      .then((res) => res.data),

  // Create a keyword coupon for a specific project
  createKeywordCoupon: (projectId: number, createKeywordCouponDto: ICoupon) =>
    kevinAuthAPI
      .post(`/coupon/${projectId}/keyword`, createKeywordCouponDto)
      .then((res) => res.data),

  // Update a specific coupon in a project
  updateCoupon: (updateCouponDto: ICoupon) =>
    kevinAuthAPI
      .put(
        `/coupon/${updateCouponDto.project_id}/${updateCouponDto.id}`,
        updateCouponDto,
      )
      .then((res) => res.data),
  deleteCoupon: (coupon: ICoupon) =>
    kevinAuthAPI
      .delete(`/coupon/${coupon.project_id}/${coupon.id}`)
      .then((res) => res.data),
};
